import { defineComponent as _defineComponent } from 'vue'
import { JobJson } from '@/models/types/job-json'
import { useRouter, useRoute } from 'vue-router/composables'


export default /*#__PURE__*/_defineComponent({
  __name: 'Batch',
  props: {
    value: null,
    job: null
  },
  setup(__props: any) {

const props = __props as {
  value?: string | null
  job: JobJson
}



const router = useRouter()
const route = useRoute()

function handleClick() {
  const batchId = props.job.invoice_id ?? ''
  const routePrefix = (route.name as string).split('-')[0]
  let targetName = ''
  // TODO: we must change the parent route prefix to filtered to stay consistent with the other parts of the navigation
  if (routePrefix === 'filtered') {
    targetName = 'filtered-job-search-batches-info-panel'
  } else {
    targetName = 'job-search-batches-info-panel'
  }
  router.push({
    name: targetName,
    params: {
      batchId,
    },
  })
}

return { __sfc: true,props, router, route, handleClick }
}

})